import React from "react";
import Header from "../HeaderOne/Main";
import Footer from "../FooterOne/Main";
import Breadcrumb from "../Breadcrumb/Main";
import ShopDetails from "../Mencart/ShopDetails";
import CardDetails from "../Mencart/CardDetails";

function Main() {
  return (
    <div>
      <Header />
      <div className="main-wrapper">
        <div className="data-scroll">
          <div className="page-wrapper">
            <div className="page-wrapper-bg-3" />
            <div className="page-wrapper-bg-4" />
            <main className="site-main">
              <Breadcrumb title="Home" subtitle="Cart" />
              <CardDetails />
              <ShopDetails />
            </main>
            <Footer />
          </div>
        </div>
      </div>
    </div>
  );
}

export default Main;
